import styled from "styled-components";

export const Z_INDEX = {
  HIGHEST: 9999,
  HIGHER: 5555,
  HIGH: 999,
  MIDDLE: 99,
  LOW: 9,
};

export const COLORS = {
  BLUE_MAIN: "#0A7CB2",
  BLUE_DARK: "#007DB7",
  BLUE_LIGHT: "#9BA6B2",
  WHITE: "#FFFFFF",
  BLACK_MAIN: "#131415",
  GREY: "#A7A4A4",
  GREY_MAIN: "#EFF5F3",
  GREY_DARK: "#252847",
  GRADIENT: "rgba(255, 255, 255, 0.252332)",
  GREEN: "#4CE6C4",
  RED: "#FF0000",
};

export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: ${Z_INDEX.HIGHER};
  background-color: ${COLORS.BLUE_LIGHT};
`;

export enum FontFamilyTypeEnum {
  GILROY="Gilroy",
  MONTSERRAT="Montserrat",
  OSWALD="Oswald",
  GILL_SANS="GillSansC",
  APEX="Conv_Apex Mk3-Medium",
}

type BasicButtonProps = {
  fontFamily?: FontFamilyTypeEnum;
  backgroundColor?: string;
  borderColor?: string;
  flexGrow?: number;
  margin?: string;
  width?: string;
  disabled?: boolean;
  fontWeight?: string;
  fontSize?: string;
  color?: string;
}

export const BasicButton = styled.button<BasicButtonProps>`
  font-family: ${({ fontFamily }) => fontFamily || FontFamilyTypeEnum.GILROY};
  padding: 13px 37.5px 12px 37.5px;
  border-radius: 12px;
  border: 1px solid;
  width: ${({ width }) => width || "auto"};
  margin: ${({ margin }) => margin || "0 0 20px 0"};
  background-color: ${({ backgroundColor, disabled }) => (disabled ? COLORS.GREY : backgroundColor || COLORS.WHITE)};
  border-color: ${({ borderColor, disabled }) => (disabled ? COLORS.GREY : borderColor || COLORS.WHITE)};
  color: ${({ color }) => color || COLORS.BLACK_MAIN};
  flex-grow: ${({ flexGrow }) => flexGrow || 0};
  font-size: ${({ fontSize }) => fontSize || "12px"};
  font-style: normal;
  font-weight: ${({ fontWeight }) => fontWeight || "400"};
  line-height: 20px;
`;

interface BasicTextProps {
  fontFamily?: FontFamilyTypeEnum;
  color?: string;
  fontSize?: string;
  lineHeight?: string;
  fontWeight?: string;
  letterSpacing?: string;
  textAlign?: "left"|"center"|"right";
  margin?: string;
  underline?: boolean;
  blockWidth?: string;
}

export const BasicText = styled.div<BasicTextProps>`
  font-family: ${({ fontFamily }) => fontFamily || FontFamilyTypeEnum.GILROY};
  font-size: ${({ fontSize }) => fontSize || "12px"};
  font-style: normal;
  font-weight: ${({ fontWeight }) => fontWeight || "400"};
  line-height: ${({ lineHeight, fontSize }) => lineHeight || fontSize || "12px"};
  letter-spacing: ${({ letterSpacing }) => letterSpacing || "0px"};
  color: ${({ color }) => color || COLORS.BLACK_MAIN};
  text-align: ${({ textAlign }) => textAlign || "center"};
  margin: ${({ margin }) => margin || 0};
  text-decoration: ${({ underline }) => (underline ? "underline" : "none")};
  width: ${({ blockWidth }) => blockWidth || "auto"};
`;

interface BasicContentWrapperProps {
  background?: string;
  color?: string;
  padding?: string;
  justifyContent?: "space-between"|"flex-start";
  scrollable?: boolean;
  width?: string;
  height?: string;
}

export const BasicContentWrapper = styled.div<BasicContentWrapperProps>`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: ${({ justifyContent }) => justifyContent || "flex-start"};
  align-items: center;
  padding: ${({ padding }) => padding || "10px 16px"}; 
  color: ${({ color }) => color || COLORS.BLACK_MAIN};
  background-color: ${({ background }) => background || "transparent"};
  overflow-y: ${({ scrollable }) => (scrollable ? "scroll" : "hidden")};
  font-family: ${FontFamilyTypeEnum.GILROY};
  width: ${({ width }) => width || "100%"};
  height: ${({ height }) => height || "auto"};
  overflow-x: hidden;
`;

interface CommonImgWrapperProps {
  width?: string;
  height?: string;
  position?: "absolute"|"fixed";
}

export const BasicImgWrapper = styled.img<CommonImgWrapperProps>`
  cursor: pointer;
  width: ${({ width }) => width || "auto"};
  height: ${({ height }) => height || "auto"};
  position: ${({ position }) => position || "relative"};
  object-fit: contain;
`;

interface ContentHeaderProps {
  height?: string;
  withoutPadding?: boolean;
  margin?: string;
}

export const ContentHeader = styled.div<ContentHeaderProps>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: ${({ height }) => height || "60px"};
  padding: ${({ withoutPadding }) => (withoutPadding ? "0" : "0 20px")};
  margin: ${({ margin }) => margin || 0};
`;

export const ContentHeaderCenterItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
`;

interface ContentHeaderItemProps {
  width?: string;
}

const ContentHeaderItem = styled.div<ContentHeaderItemProps>`
  display: flex;
  align-items: center;
  width: ${({ width }) => width || "15%"};
`;

export const ContentHeaderLeftItem = styled(ContentHeaderItem)`
  justify-content: flex-start;
`;

export const ContentHeaderRightItem = styled(ContentHeaderItem)`
  justify-content: flex-end;
`;

export const ScrollableBlock = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;

  ::-webkit-scrollbar {
    display: none;
  }
`;
